import React from 'react'
import { Button, Form } from 'react-bootstrap'
import { CustomDateInput } from './Function_utils'
import DatePicker from 'react-datepicker'
import { planDuration, sbnType } from './DropdownValues'

function FilterBar(props) {
    return (
        <>
            {(props.displayPage === "Activity" || props.displayPage === "Payment") ?
                <div className="subscription-toolbar">
                    <div className="toolbar-left">
                        <div className="search-box">

                            <i className='bx bx-search'></i>

                            <input
                                name="search_text"
                                placeholder="Search customer..."
                                value={props.filterValues.search_text}
                                onChange={(e) => props.handleFilterValues(e)}
                            />

                        </div>
                        {props.displayPage === "Activity" && <Form.Group controlId="contactLevel">
                            <Form.Select
                                name={props.select_type}
                                value={props.displayPage === "Activity" ? props.filterValues.activity_type : props.filterValues.plan || ""}
                                onChange={(e) => props.handleFilterValues(e)}
                            >
                                <option value="">Select Type</option>
                                {props.select_values.map((item) => (
                                    <option key={item.value} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>}
                        <DatePicker
                            selected={props.filterValues.from_date}
                            onChange={(date) => props.handleDateChange("from_date", date)}
                            maxDate={new Date()}
                            placeholderText="Select From Date"
                            dateFormat="dd/MM/yyyy"
                            customInput={
                                <CustomDateInput
                                    placeholderText="Select From Date"
                                    onClear={() => props.handleDateChange("from_date", null)}
                                />
                            }
                        />
                        <DatePicker
                            selected={props.filterValues.to_date}
                            onChange={(date) => props.handleDateChange("to_date", date)}
                            minDate={props.filterValues.from_date || null}
                            maxDate={new Date()}
                            placeholderText="Select To Date"
                            dateFormat="dd/MM/yyyy"
                            customInput={
                                <CustomDateInput
                                    placeholderText="Select To Date"
                                    onClear={() => props.handleDateChange("to_date", null)}
                                />
                            }
                        />

                    </div>

                    <div className="view-btns">

                        <Button className="active" onClick={props.searchFunction}>
                            <i className='bx bx-search'></i>
                        </Button>

                        <Button onClick={props.clearFunction}>
                            <i className='bx bx-x-circle'></i>
                        </Button>

                    </div>

                </div>
                :
                <div className="subscription-toolbar">
                    <div className="toolbar-left">
                        <div className="search-box">

                            <i className='bx bx-search'></i>

                            <input
                                name="search_text"
                                placeholder="Search customer..."
                                value={props.filterValues.search_text}
                                onChange={(e) => props.handleFilterValues(e)}
                            />

                        </div>

                        <Form.Group controlId="contactLevel">
                            <Form.Select
                                name="sbn_type"
                                value={props.filterValues.sbn_type || ""}
                                onChange={(e) => props.handleFilterValues(e)}
                            >
                                <option value="">Select plan</option>
                                {sbnType.map((item) => (
                                    <option key={item.value} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="contactLevel">
                            <Form.Select
                                name="plan_type"
                                value={props.filterValues.plan_type || ""}
                                onChange={(e) => props.handleFilterValues(e)}
                            >
                                <option value="">Select Plan Duration</option>
                                {planDuration.map((item) => (
                                    <option key={item.value} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="contactLevel">
                            <Form.Select
                                name="active_status"
                                value={props.filterValues.active_status || ""}
                                onChange={(e) => props.handleFilterValues(e)}
                            >
                                <option value="">Select Plan Duration</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>

                            </Form.Select>
                        </Form.Group>
                        <DatePicker
                            selected={props.filterValues.from_date}
                            onChange={(date) => props.handleDateChange("from_date", date)}
                            maxDate={new Date()}
                            placeholderText="Select From Date"
                            dateFormat="dd/MM/yyyy"
                            customInput={
                                <CustomDateInput
                                    placeholderText="Select From Date"
                                    onClear={() => props.handleDateChange("from_date", null)}
                                />
                            }
                        />
                        <DatePicker
                            selected={props.filterValues.to_date}
                            onChange={(date) => props.handleDateChange("to_date", date)}
                            minDate={props.filterValues.from_date || null}
                            maxDate={new Date()}
                            placeholderText="Select To Date"
                            dateFormat="dd/MM/yyyy"
                            customInput={
                                <CustomDateInput
                                    placeholderText="Select To Date"
                                    onClear={() => props.handleDateChange("to_date", null)}
                                />
                            }
                        />

                    </div>

                    <div className="view-btns">

                        <Button className="active" onClick={props.searchFunction}>
                            <i className='bx bx-search'></i>
                        </Button>

                        <Button onClick={props.clearFunction}>
                            <i className='bx bx-x-circle'></i>
                        </Button>

                    </div>
                </div>
            }
        </>
    )
}

export default FilterBar
